import * as React from "react";
import styled from "styled-components";
import Navigation from "./navigation";
import Drawer from "./drawer";

const TopBar = styled.div`
  height: 5px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.emperor};
`;

const HeaderRoot = styled.div`
  align-items: center;
  display: flex;
  height: 60px;
  justify-content: space-between;
  overflow: hidden;
  padding: 0px 16px;
`;

const Header = ({
  renderTitle,
  menuItems,
  renderSubscriptionBar,
  noTopBar = false,
}) => {
  return (
    <header>
      {noTopBar ? null : <TopBar />}
      <HeaderRoot>
        {renderTitle()}
        <Navigation menuItems={menuItems} />
        <Drawer items={menuItems} />
      </HeaderRoot>
      {renderSubscriptionBar()}
    </header>
  );
};

export default Header;
